export default __webpack_public_path__ + "static/media/services1.b9633ba0.png";